__turbopack_context__.v({
  "folderTreeContainer": "FolderTree-module__2Tvk4G__folderTreeContainer",
});
